import React from 'react';
import { Check, CreditCard } from 'lucide-react';
export function PricingSection() {
  return <section id="compra" className="bg-gray-900 py-16 px-4 md:px-8" data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-yellow-400" data-id="element-113">
          <div className="bg-yellow-400 py-4 px-6 text-center" data-id="element-114">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900 uppercase" data-id="element-115">
              🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO
            </h2>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-116">
            <h3 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-117">
              MEGA PACK CIENCIAS SOCIALES LISTA
            </h3>
            <p className="text-xl text-gray-600 mb-8 font-medium" data-id="element-118">
              5 Tomos Base + 2 Bonos PRO
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left max-w-2xl mx-auto mb-10" data-id="element-119">
              {['Pago único', 'Acceso de por vida', 'Descarga inmediata', 'Garantía 7 días', '2 Bonos incluidos'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-120">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-121" />
                  <span className="text-gray-800 font-medium" data-id="element-122">{item}</span>
                </div>)}
            </div>

            <div className="mb-10" data-id="element-123">
              <p className="text-gray-500 text-xl md:text-2xl line-through mb-2" data-id="element-124">
                Precio regular $49.990 ARS
              </p>
              <p className="text-6xl md:text-7xl font-black text-green-600 tracking-tight" data-id="element-125">
                $19.990{' '}
                <span className="text-2xl md:text-3xl font-bold text-gray-500" data-id="element-126">
                  ARS
                </span>
              </p>
              <p className="text-gray-500 mt-2" data-id="element-127">
                Pago único · Pagarás en pesos argentinos
              </p>
            </div>

            <a href="https://mi-tienda-pro-8012.myshopify.com/cart/48253016375515:1" className="block w-full max-w-2xl mx-auto bg-green-600 hover:bg-green-700 text-white text-2xl md:text-4xl font-bold py-6 px-8 rounded-lg shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-200 animate-pulse mb-8" data-id="element-128">
              👉 SÍ, QUIERO EL MEGA PACK
            </a>

            <div className="border-t border-gray-200 pt-8" data-id="element-129">
              <p className="text-sm text-gray-500 mb-4 font-bold uppercase tracking-wide" data-id="element-130">
                Métodos de pago seguros
              </p>
              <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-gray-400 grayscale opacity-70" data-id="element-131">
                <span className="font-bold text-lg" data-id="element-132">MERCADO PAGO</span>
                <span className="font-bold text-lg" data-id="element-133">VISA</span>
                <span className="font-bold text-lg" data-id="element-134">MASTERCARD</span>
                <span className="font-bold text-sm border border-gray-300 rounded px-2 py-1" data-id="element-135">
                  TRANSFERENCIA SOLO POR WHATSAPP
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* How to receive */}
        <div className="mt-16 text-center text-white" data-id="element-136">
          <h3 className="text-2xl font-bold mb-8" data-id="element-137">
            🔽 ¿Cómo recibís el material?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-138">
            <div className="bg-gray-800 p-6 rounded-lg" data-id="element-139">
              <div className="text-yellow-400 font-black text-4xl mb-4" data-id="element-140">1</div>
              <p data-id="element-141">Realizás la compra e ingresás tu correo electrónico.</p>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg" data-id="element-142">
              <div className="text-yellow-400 font-black text-4xl mb-4" data-id="element-143">2</div>
              <p data-id="element-144">Finalizás el pago.</p>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg" data-id="element-145">
              <div className="text-yellow-400 font-black text-4xl mb-4" data-id="element-146">3</div>
              <p data-id="element-147">Recibís automáticamente el link del material en tu correo.</p>
            </div>
          </div>
          <p className="mt-8 text-gray-400 italic" data-id="element-148">
            📩 Si no lo ves en tu bandeja principal, revisá spam o correo no
            deseado.
          </p>
        </div>
      </div>
    </section>;
}